export default __webpack_public_path__ + "static/2025-img-articolo-marzo2-aec567e70582b767c8e1ff7f297748f4.jpg";